import {
    TipoPermissao,
    type UsuarioPermissao,
} from '@/features/usuario/types/UsuarioTipoPermissao';
import { getUsuarioEmpresa } from '.';

export function isPermissionParcialOrFull(permission: TipoPermissao): boolean {
    return permission === TipoPermissao.Parcial || permission === TipoPermissao.Completo;
}

export function isPermissionFull(permission: TipoPermissao): boolean {
    return permission === TipoPermissao.Completo;
}

type UserPermissions = Record<string, unknown> | null | undefined;

export function resolveUserPermissions<T extends Record<string, TipoPermissao>>(
    requiredPermissions: T,
    userPermissions: UserPermissions,
): { [K in keyof T]: boolean } {
    return (Object.keys(requiredPermissions) as Array<keyof T>).reduce(
        (permissions, permission) => {
            const requiredLevel = requiredPermissions[permission];
            const userLevel = userPermissions?.[permission as string];

            permissions[permission] =
                requiredLevel === TipoPermissao.Completo
                    ? isPermissionFull(userLevel as TipoPermissao)
                    : isPermissionParcialOrFull(userLevel as TipoPermissao);

            return permissions;
        },
        {} as { [K in keyof T]: boolean },
    );
}

export function getUserPermission(
    permissao: Omit<UsuarioPermissao, 'upp_sistema_acesso'>,
): TipoPermissao {
    const usuario_tipo_permissao = getUsuarioEmpresa()?.usuario_tipo_permissao;

    const permission =
        usuario_tipo_permissao?.[permissao as UsuarioPermissao] || TipoPermissao.Bloqueado;

    return permission as TipoPermissao;
}

export function getUserPermissions(): Record<UsuarioPermissao, TipoPermissao> {
    const userPermissions = getUsuarioEmpresa()?.usuario_tipo_permissao;

    return (userPermissions || {}) as Record<UsuarioPermissao, TipoPermissao>;
}

export function userHasPermission(
    permissao: UsuarioPermissao,
    nivel: TipoPermissao.Completo | TipoPermissao.Parcial,
): boolean {
    const userPermission = getUserPermission(permissao);

    if (nivel === TipoPermissao.Completo) {
        return isPermissionFull(userPermission);
    }

    return isPermissionParcialOrFull(userPermission);
}
